<ng-container *ngIf="items && itemTemplate">
  <div class="slider-wrapper">
    <ng-container *ngIf="!insufficientItems; else insufficientItemsTpl">
      <ng-container *ngIf="inGrid; else defaultTpl">
        <div class="slider-container-outer" [ngClass]="containerClass">
          <div class="slider-container">
            <div class="row slider-base-track" #track (touchstart)="dragStart($event)" (mousedown)="dragStart($event)">
              <div class="slide-item" *ngFor="let item of items; let index = index" [ngStyle]="style">
                <ng-container
                  *ngTemplateOutlet="
                    itemTemplate;
                    context: {
                      index: index,
                      item: item,
                      active: index === activeIndex
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
          <div class="prev-arrow-wrapper">
            <span class="arrow-item" (click)="prev()">
              <span class="mb-icon mb-icon-back"></span>
            </span>
          </div>
          <div class="next-arrow-wrapper">
            <span class="arrow-item" (click)="next()">
              <span class="mb-icon mb-icon-forward"></span>
            </span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <mb-slider-navigation
    *ngIf="navItems.length > 1"
    [length]="navItems.length"
    [activeIndex]="activeIndex"
    (indexChange)="slideTo($event)"
    class="navigation"
  ></mb-slider-navigation>
</ng-container>

<ng-template #defaultTpl>
  <div class="slider-base-track" #track (touchstart)="dragStart($event)" (mousedown)="dragStart($event)">
    <div class="slide-item" *ngFor="let item of items; let index = index" [ngStyle]="style">
      <ng-container
        *ngTemplateOutlet="
          itemTemplate;
          context: {
            index: index,
            item: item,
            active: index === activeIndex
          }
        "
      ></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #insufficientItemsTpl>
  <ng-container *ngIf="inGrid; else insufficientItemsNoGridTpl">
    <div [ngClass]="containerClass">
      <div class="row">
        <div class="slide-item insufftpl" *ngFor="let item of originalItems; let index = index" [ngStyle]="style">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                index: index,
                item: item,
                active: index === activeIndex
              }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #insufficientItemsNoGridTpl>
    <div class="slide-item" *ngFor="let item of originalItems; let index = index" [ngStyle]="style">
      <ng-container
        *ngTemplateOutlet="
          itemTemplate;
          context: {
            index: index,
            item: item,
            active: index === activeIndex
          }
        "
      ></ng-container>
    </div>
  </ng-template>
</ng-template>
